import React from 'react';
import tpl from '../templates/a-business';
import BaseNewCardView from '../../../../Cards/views/BaseNewCardView';

export default class extends BaseNewCardView {
    template = tpl;

    static displayName = 'Business.Views.ABusiness';
}
